export function getDefaultFilters() {
  return {
    pageNumber: 1,
    filterData: {
      filterOptions: {},
      sortingOptions: {}
    }
  }
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Patients/helpers.js